import {
    StringValueFilterModel,
    ValuesFilterModel,
} from '@ag-table-lib/filter.model'
import { ConnectStatus } from '@shared-util-lib/models/connector.model'

export enum FleetMileageStatus {
    ActualExceeding = 'ACTUAL_EXCEEDING',
    PredictedExceeding = 'PREDICTED_EXCEEDING',
    ActualBelow = 'ACTUAL_BELOW',
    NoData = 'NO_DATA',
}

export interface FleetMileageStatusInformation {
    amountOfWagons: number
    status: FleetMileageStatus
}

export interface FleetMileageStatusResponseBody {
    status: FleetMileageStatusInformation[]
}

export interface FleetWagonWithMileage {
    wagonId: string
    wagonNumber: string
    connectStatus: ConnectStatus
    mileageStatus: FleetMileageStatus
    currentMileage: number
    contractualMileage?: number
    mileageProjection?: number
}

export interface FleetMileageResponseBody {
    wagonMileages: FleetWagonWithMileage[]
}

export enum MileageColumnId {
    MILEAGE_STATUS = 'MILEAGE_STATUS',
    CONNECT_STATUS = 'CONNECT_STATUS',
    WAGON_NUMBER = 'WAGON_NUMBER',
    CURRENT_MILEAGE = 'CURRENT_MILEAGE',
    CONTRACTUAL_MILEAGE = 'CONTRACTUAL_MILEAGE',
    MILEAGE_PREDICTION = 'MILEAGE_PREDICTION',
}

export interface MileageTableFilterModel {
    [MileageColumnId.MILEAGE_STATUS]?: ValuesFilterModel<FleetMileageStatus>[]
    [MileageColumnId.WAGON_NUMBER]?: StringValueFilterModel[]
}
